import DemoTransactionsTableItem from './DemoTransactionsTableItem'

export default DemoTransactionsTableItem
